import React from 'react';
import PropTypes from 'prop-types';
import TextFieldBase from './TextFieldBase';

class TextField extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override TextFieldBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <TextField> */
    className: PropTypes.string,
    /** If `true`, the input will not have an underline. */
    disableUnderline: PropTypes.bool,
    /** If `true`, textfield will be in error state */
    hasError: PropTypes.bool,
    /** If `true`, password will be visible */
    showPassword: PropTypes.bool,
    /** Override or extend default styles */
    styles: PropTypes.object,
    /** Name attribute of the `input` element. */
    name: PropTypes.string,
    /** Value of `input` element */
    value: PropTypes.string,
    /** Type of the input element. It should be a valid HTML5 input type. */
    type: PropTypes.string,
    /** Text used for input label */
    label: PropTypes.string,
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,
    /** Shorten label with ellipsis */
    useEllipsisLabel: PropTypes.bool,
    /** reduce width of label if textfield has icon */
    ellipsisAdjustIcon: PropTypes.bool,
  };

  static defaultProps = {
    styleType: 'default',
    hasError: false,
    disableUnderline: true,
    showPassword: false,
    useEllipsisLabel: false,
    ellipsisAdjustIcon: false,
  };

  getStyles = type => {
    switch (type) {
      case 'search':
        return {
          textField: {
            maxWidth: '100%',
            backgroundColor: '#FFF',
            border: '1px solid #C4C4CE',
          },
        };
      case 'chat':
        return {
          textField: {
            maxWidth: '100%',
          },
          formLabel: {
            fontSize: '12px',
            paddingLeft: '18px',
          },
          formControl: {
            transform: 'translate(0, 18px) scale(1)',
          },
        };
      case 'documentLandingSearch':
        return {
          root: {
            border: '0.5px solid #EAEAF2',
            backgroundColor: '#F6F6FA',
          },
          inputRoot: {
            marginTop: '16px !important',
          },
          textField: {
            height: '51px',
            maxWidth: '100%',
            marginBottom: '5px',
          },
          floatLabel: {
            margin: '0 0 0 0.5rem',
          },
          floatLabelShrink: {
            margin: '0.5rem 0 0 0.5rem',
            fontSize: '10px',
          },
        };
      case 'date':
        return {
          inputRoot: {
            height: '50px',
            top: '0px',
            // left: '-4px',
            paddingLeft: '3px',
            position: 'relative',
            margin: '0px !important',
          },
          inputDom: {
            left: '4px',
            top: '9px',
            position: 'relative',
            height: '32px',
            '&::placeholder': {
              position: 'relative',
              top: '1px',
              left: '0px',
            },
          },
        };

      case 'login':
        return {
          textField: {
            backgroundColor: '#181820',
            maxWidth: '520px',
            height: '64px',
          },
          formControl: {
            transform: 'translate(0, 24px) scale(1)',
          },
          textFieldFocus: {
            border: 'solid 1px #181820',
          },
          inputRoot: {
            color: '#FFF',
            paddingLeft: '14px',
            fontFamily: 'arial, sans-serif !important',
          },
          formLabel: {
            paddingLeft: '16px',
            color: '#FFF',
          },
          formHelperText: {
            position: 'absolute',
            bottom: '-17px',
          },
          visibilityIcon: {
            top: 'auto',
          },
          visibilityIconRoot: {
            color: '#FFF',
          },
        };

      case 'profile':
        return {
          textField: {
            backgroundColor: '#F6F5FA',
            maxWidth: '520px',
            height: '48px',
          },
          formControl: {
            transform: 'translate(0, 18px) scale(1)',
          },
          textFieldFocus: {
            // border: 'solid 1px #e1e1e6',
          },
          inputRoot: {
            color: 'black',
            paddingLeft: '12px',
            fontSize: '',
            fontFamily: 'EYInterstate, sans-serif !important',
          },
          formLabel: {
            paddingLeft: '16px',
            color: '#44434C',
          },
          formHelperText: {
            marginTop: '5px',
            fontSize: '9px',
            minWidth: '275px',
          },
          visibilityIcon: {
            top: 'auto',
          },
          visibilityIconRoot: {
            color: '#FFF',
          },
        };
      case 'registration':
        return {
          textField: {
            backgroundColor: '#F6F5FA',
            maxWidth: '520px',
            height: '48px',
          },
          formControl: {
            transform: 'translate(0, 14px) scale(1)',
            paddingLeft: '14px',
          },
          textFieldFocus: {
            // border: 'solid 1px #e1e1e6',
          },
          inputRoot: {
            color: 'black',
            fontSize: '',
            fontFamily: 'EYInterstate, sans-serif !important',
            paddingLeft: '10px !important',
          },
          formLabel: {
            paddingLeft: '16px',
            color: '#44434C',
          },
          formHelperText: {
            marginTop: '5px',
            fontSize: '9px',
            minWidth: '275px',
          },
          visibilityIcon: {
            top: 'auto',
          },
          visibilityIconRoot: {
            color: '#FFF',
          },
        };
      case 'enterCode':
        return {
          textField: {
            margin: '25px 20px',
            minWidth: '220px',
          },
        };
      case 'multiline':
        return {
          textField: {
            minHeight: '48px',
            height: 'auto',
            border: '1px solid #C4C4CE !important',
            borderRadius: '4px',
            maxWidth:'100%',
            marginBottom: '27px'
          },
          inputRoot: {
            margin: 'auto 0',
            padding: '0px',
            marginTop: 'auto',
            width: 'auto',
            paddingLeft: '10px'
          },
          inputDom:{
            overflow: 'hidden',
          },
          inputMultiline: {
            padding: '15px 0px'
          },
          enableTextField:{
            "&:hover, &:focus-within":{
              background: '#F6F5FA',
            }
          }
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType, readOnly, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);
    return <TextFieldBase styles={styles} disabled={readOnly} {...otherProps} />;
  }
}

export default TextField;
